module.exports = __webpack_public_path__ + "static/media/home.2492ca06.png";